import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import {
  RISK_LEVELS,
  SEGMENTS_CONST,
} from 'src/app/shared/constants/rate.constants';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
@Component({
  selector: 'app-plazo-monto',
  templateUrl: './plazo-monto.component.html',
  styleUrls: ['./plazo-monto.component.scss'],
})
export class PlazoMontoComponent implements OnInit {
  /**
   * Texto de error para campo de email
   *
   * *Error text for email field*
   *
   * @access public
   * @type {string}
   */
  reactiveErrorPlazo = '';
  flag = true;
  formGroup: FormGroup;
  showOptions: boolean;
  option = 'number';
  quantity: any;
  formGroupSelect: FormGroup;

  selectedloan: any;
  back: any;
  select_products: any[] = [];
  maxPeriod: any;
  taxRates: any;
  activeInput = false;
  showRate = false;
  quantityModel: any;
  reactiveErrormonto: '';
  description: any;
  data: any;
  description_plazo: any;
  description_plazo_no_empleado: any;
  error_monto: any;
  min: any;
  error_plazo: any;
  plazo_min: any;
  plazo_max: any;
  readonly SEGMENTS_CONST = SEGMENTS_CONST;
  readonly RISK_LEVELS = RISK_LEVELS;
  validButton = false;
  amount: any;
  periodValue: any;
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    private bitacoraService: BitacoraService,
    private requestService: RequestService,
    public abreCuentasService: AbreCuentasService,
    private helperService: HelpersService,
    private parameterService: ParametersService,
    private taggingService: TaggingService,
  ) {
    this.data = this.abreCuentasService
      .getProductsSelects()
      .find((s: any) => s.flow === 'freeInvestment' || 'loan');
    this.error_plazo = this.copyService.copies.plazo_monto_val[0][this.data.flow].msgIni;
    this.min = this.copyService.copies.plazo_monto_val[0][this.data.flow].montoMin;
    this.plazo_min = this.copyService.copies.plazo_monto_val[0][this.data.flow].plazoMin;
    this.headerService.show(true, false, true);
    this.showOptions = false;
    this.plazo_max = this.abreCuentasService.getOccupationSelected().name == 'Empleado' ? this.copyService.copies.plazo_monto_val[0][this.data.flow].plazoMax : this.copyService.copies.plazo_monto_val[0][this.data.flow].plazoMax2;

    this.formGroup = this.formBuilder.group({
      monto: [
        '',
        [
          Validators.required,
          Validators.min(this.min),
          Validators.pattern(/^[0-9,$]*$/),
        ],
      ],
      plazo: [
        '',
        [
          Validators.required,
          Validators.min(
            parseInt(
              this.copyService.copies.plazo_monto_val[0][this.data.flow]
                .plazoMin,
              10,
            ),
          ),
          Validators.max(parseInt(this.plazo_max, 10)),
        ],
      ],
    });
  }

  defaultParameter(valor: string) {
    return valor === '' || valor === undefined ? '0' : valor;
  }

  /**
   * Summary initial event, customer information
   */
  ngOnInit() {
    this.sendTagging('init');
    if (!this.abreCuentasService.haveLoan) {
      this.getRates();
    }
    this.description =
      this.copyService.copies.plazo_monto_val[0][
        this.data.flow
      ].descripcion_monto;
    this.error_monto =
      this.copyService.copies.plazo_monto_val[0][this.data.flow].msg_error;
    this.min =
      this.copyService.copies.plazo_monto_val[0][this.data.flow].montoMin;
    this.quantity = this.abreCuentasService.getLoanModel();
    this.select_products = this.abreCuentasService.getProductsSelects();
    if (this.abreCuentasService.getOccupationSelected().name == 'Empleado') {
      this.flag = false;
      this.description_plazo =
        this.copyService.copies.plazo_monto_val[0][this.data.flow].descripcion;
    } else {
      if (
        this.abreCuentasService.getOccupationSelected().name == 'Pensionado'
      ) {
        this.flag = true;
      }
      this.description_plazo = this.msnErrorPlazo();
    }
    this.controlPrevious();
  }

  previous() {
    this.sendTagging('prev', 'bottom', '2');

  }

  controlPrevious() {
    const periodValue =
      this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue;
    const amountValue =
      this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue;
    this.amount = amountValue ? amountValue : '';
    this.formGroup.controls.plazo.setValue(periodValue);
    if (amountValue != undefined && periodValue != undefined) {
      this.updateValuemonto({ target: { value: amountValue } });
      const convert = this.amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
      this.formGroup.controls.monto.setValue('$' + convert);
      this.reactiveInputChangeMonto();
    } else {
      this.validButton = false;
    }
  }

  getRates() {
    this.requestService
      .getRatesFromServer()
      .then((res: any) => {
        this.requestService.setRates(res.products[0].segments);
        this.taxRates = res.products[0].segments;
        this.showRate = !this.abreCuentasService.haveLoan;
      })
      .catch(() => this.navigationService.navigateToGeneralInformation('127'));
  }

  updateValuemonto(event: any) {
    const plazoControl = this.formGroup.controls.plazo as FormControl;
    const value = event.target.value;
    const newvalue = this.helperService.currency(value);
    const replacecopy = this.copyService.copies.plazo_monto_val.find(
      (s: any) =>
        s[this.data.flow].montoMin <= newvalue.clearValue &&
        s[this.data.flow].montoMax > newvalue.clearValue,
    );
    if (replacecopy) {
      if (
        replacecopy[this.data.flow].montoMin <= newvalue.clearValue &&
        replacecopy[this.data.flow].montoMax > newvalue.clearValue
      ) {
        this.description_plazo = replacecopy[this.data.flow].descripcion2;
        this.description = replacecopy[this.data.flow].descripcion_monto2;
      }
      // else {
      //   this.description_plazo = replacecopy[this.data.flow].descripcion;
      //   this.description = replacecopy[this.data.flow].descripcion_monto;
      // }
      this.error_monto = replacecopy[this.data.flow].msg_error;
      this.error_plazo = replacecopy[this.data.flow].msgplazo_error;
      this.formGroup.controls.monto.clearValidators();
      this.formGroup.controls.monto.setValidators([
        Validators.required,
        Validators.min(parseInt(replacecopy[this.data.flow].montoMin, 10)),
        Validators.max(parseInt(replacecopy[this.data.flow].montoMax, 10)),
        Validators.pattern(/^[0-9,$]*$/),
      ]);
      plazoControl.clearValidators();
      plazoControl.setValidators([
        Validators.required,
        Validators.min(parseInt(replacecopy[this.data.flow].plazoMin, 10)),
        Validators.max(parseInt(replacecopy[this.data.flow].plazoMax, 10)),
      ]);
    } else {
      if (newvalue.clearValue <= this.copyService.copies.plazo_monto_val[0][this.data.flow].montoMin) {
        this.error_monto = this.copyService.copies.plazo_monto_val[0][this.data.flow].msg_error;
        this.error_plazo = this.msnErrorPlazo();
        this.description_plazo =
          this.abreCuentasService.getOccupationSelected().name == 'Empleado' ?
            this.copyService.copies.plazo_monto_val[0][
              this.data.flow
            ].descripcion :
            this.copyService.copies.plazo_monto_val[0][
              this.data.flow
            ].descripcion2;
        plazoControl.clearValidators();
        plazoControl.setValidators([
          Validators.required,
          Validators.min(parseInt(this.plazo_min, 10)),
          Validators.max(parseInt(this.plazo_max, 10)),
        ]);
      } else if (newvalue.clearValue > this.copyService.copies.plazo_monto_val[1][this.data.flow].montoMax) {
        this.error_plazo = this.msnErrorPlazo();
        this.error_monto = this.copyService.copies.plazo_monto_val[1][this.data.flow].msg_error;
        plazoControl.clearValidators();
        plazoControl.setValidators([
          Validators.required,
          Validators.min(parseInt(this.plazo_min, 10)),
          Validators.max(
            parseInt(
              this.plazo_max,
              10,
            ),
          ),
        ]);
      }
    }
    if (plazoControl.value) {
      plazoControl.setValue(plazoControl.value);
    }
    this.formGroup.controls['monto'].setValue(newvalue.clearValue);
    event.target.value = newvalue.format;
    this.formGroup.updateValueAndValidity();
    this.reactiveInputChangePlazo();
  }

  msnErrorPlazo() {
    let msn = this.copyService.copies.plazo_monto_val[0][this.data.flow].descriptionInitial;
    if (this.data.flow === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
      msn = this.abreCuentasService.getOccupationSelected().name == 'Empleado' ?
        this.copyService.copies.plazo_monto_val[0][
          this.data.flow
        ].descripcion :
        this.copyService.copies.plazo_monto_val[0][
          this.data.flow
        ].descripcion2;
    }
    return msn;
  }

  reactiveInputChangePlazo(): void {
    const plazoControl = this.formGroup.controls.plazo as FormControl;
    const montoControl = this.formGroup.controls.monto as FormControl;
    if (!montoControl.valid) {
      plazoControl.invalid.valueOf();
      plazoControl.clearValidators();
      plazoControl.setValidators([
        Validators.required,
        Validators.min(parseInt('0', 10)),
        Validators.max(parseInt('0', 10)),
      ]);
      this.formGroup.updateValueAndValidity();
      this.error_plazo = this.copyService.copies.plazo_monto_val[0][this.data.flow].msgIni;
    }
    if (this.formGroup.valid) {
      this.formGroup.disable();
      this.formGroup.enable();
      this.validButton = true;
    } else {
      this.validButton = false;
    }
  }

  reactiveInputChangeMonto() {
    const MontoControl = this.formGroup.controls.monto as FormControl;
    this.reactiveErrormonto = MontoControl.valid
      ? ''
      : this.copyService.copies.monto_monto_error;
  }

  reactiveInputChangequantity() {
    const controlquantity = this.formGroup.controls['monto'] as FormControl;
    const value = controlquantity.value.split('.');
    this.quantity = value[0];
  }

  reactiveOnFocus() {
    this.activeInput = true;
  }
  /**
   * Summary next event validation
   */
  next() {
    this.sendTagging('next', 'bottom', '3');

    this.formGroup.controls['monto'].setValue(this.formGroup.controls['monto'].value.toString().replace(/[\$\.]/g, ''));
    const amountFormat = this.helperService.currency(
      this.formGroup.controls['monto'].value.toString(),
    );
    this.quantity = amountFormat;
    const bitacoraEvent = 'monthly_payment_value_purchase_credit';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.abreCuentasService.setSaveValuePlazoMonto(this.quantity.clearValue);
    this.abreCuentasService.setLoanModel(this.formGroup.value);
    this.bitacoraService.saveDataInBitacora(
      'Term_' + this.formGroup.value.plazo,
    );
    this.bitacoraService.saveDataInBitacora(
      'Amount_' + this.formGroup.value.monto,
    );
    this.abreCuentasService.getAbreCuentasModel().creditParms.maxPeriodValue =
      this.formGroup.value.plazo;
    this.abreCuentasService.getAbreCuentasModel().creditParms.maxAmountValue =
      this.formGroup.value.monto;
    this.abreCuentasService.getAbreCuentasModel().creditParms.rateValue =
      this.taxRates;
    this.getRatesLoan();
    if (this.abreCuentasService.getProductsSelects().length >= 2) {
      this.navigationService.nextStep('200');
    } else {
      this.navigationService.nextStep('205');
    }
  }

  getRatesLoan() {
    if (this.data.flow === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
      let plazo = Number(this.formGroup.value.plazo);
      let tasasfrecuencia = this.parameterService.getSetting(
        OpEnum.TASASLIBRANZAFRECUENCIA,
      );
      let tasaslibranza = this.parameterService.getSetting(OpEnum.TASASLIBRANZA);
      let keylibranza: any;
      if (plazo < tasasfrecuencia.minimo) {
        keylibranza = this.abreCuentasService.viewOptionMultiProduct
          ? tasaslibranza.multi48
          : tasaslibranza.mono48;
      } else if (
        plazo >= tasasfrecuencia.minimo &&
        plazo <= tasasfrecuencia.maximo
      ) {
        keylibranza = this.abreCuentasService.viewOptionMultiProduct
          ? tasaslibranza.multi48_96
          : tasaslibranza.mono48_96;
      } else {
        keylibranza = this.abreCuentasService.viewOptionMultiProduct
          ? tasaslibranza.multi96
          : tasaslibranza.mono96;
      }
      let rates: any = this.abreCuentasService.getAgreementSelected().rates;
      this.abreCuentasService.setRatesLoan(
        rates.find(element => element.key === keylibranza).value,
      );
    }
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '1';
    const extras = {
      pageValue: 'PlazoMonto',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
